import PlatformAccess from '@advisor/models/store/settings/PlatformAccess';
import {Constants} from '@advisor/util/constants';

export default class Default {
  constructor() {
    this.sideBarMenu = [];
    this.quickAccessButton = [];
    this.miniDrawer = null;
    this.advisorFilter = [];
    this.showDrawer = window.innerWidth > Constants.MOBILE_BREAK_POINT;
    this.mobile = window.innerWidth < Constants.MOBILE_BREAK_POINT;
    this.activeQuickAccessButton = [];
    this.platformAccess = new PlatformAccess();
    this.quickButtonPermission = [];
    this.riaComponent = null;
  }
}
